<template>
  <pt-label-table class="pt-label-table__withData" @getTableData="getTableData" :tableData="tableData" :totalNumber="totalNumber"
  :pageSize="pageSize" :tableLabels="tableLabels">
  <slot/>
  </pt-label-table>
</template>

<script>
import PtLabelTable from './index'
export default {
  name: 'pt-label-table__withData',
  components: {
    'pt-label-table': PtLabelTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      page: 0,
      totalNumber: 0,
      tableData: []
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getTableData(0)
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      this.page = page
      let data = {
        example: {
          ...this.paramsData
        },
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getLabelsList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res)
        }
      }).catch(err => {
        this.$message.error(err || '获取标签列表失败')
      })
    }
  }
}
</script>
